import { createRequest, getError } from "Utils/requestUtils";
import { call, put, takeLatest } from "redux-saga/effects";
import { Brand, Model, OperationType } from "./interfaces";
import {
  findBrandsByYearStart,
  findBrandsByYearSucceeded,
  findModelsByYearAndBrandStart,
  findModelsByYearAndBrandSucceeded,
  operationFailed,
} from "./slice";

import { VEHICLE_TYPE } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/vehicleConstants";
import { removeWhitespace } from "Formatting/index";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* findBrandsByYear({
  payload,
}: ReturnType<typeof findBrandsByYearStart>) {
  try {
    const vehicleType = getVehicleTypeUrl(payload.vehicleType);
    const finalEndpointUrl = `/open/insurance/vehicle/${vehicleType}/brands/${payload.year}`;
    const { data } = yield call(createRequest, {
      method: "get",
      url: finalEndpointUrl,
    });

    const CORPORATE_TRACTOR = "ARBEIDSMASKIN";
    const LORRY = "LASTEBIL";
    const brands = data.brands as Brand[];
    const filteredBrands = brands.filter(
      (brand) => brand.name !== CORPORATE_TRACTOR && brand.name !== LORRY,
    );

    yield put(
      findBrandsByYearSucceeded({
        year: payload.year,
        brands: filteredBrands,
      }),
    );
  } catch (e) {
    yield put(
      operationFailed({
        year: payload.year,
        error: {
          operationType: OperationType.FIND_MODELS_BY_YEAR_AND_BRAND,
          response: getError(e),
        },
      }),
    );
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* findModelsByYearAndBrand({
  payload,
}: ReturnType<typeof findModelsByYearAndBrandStart>) {
  const vehicleType = getVehicleTypeUrl(payload.vehicleType);
  const brand =
    payload.vehicleType === VEHICLE_TYPE.CAR
      ? removeWhitespace(payload.brand).toLowerCase()
      : payload.brand;
  const url = `/open/insurance/vehicle/${vehicleType}/${brand}/${payload.year}`;
  try {
    const { data } = yield call(createRequest, {
      method: "get",
      url,
    });
    yield put(
      findModelsByYearAndBrandSucceeded({
        year: payload.year,
        brand: payload.brand,
        models: data.models as Model[],
      }),
    );
  } catch (e) {
    yield put(
      operationFailed({
        year: payload.year,
        brand: payload.brand,
        error: {
          operationType: OperationType.FIND_MODELS_BY_YEAR_AND_BRAND,
          response: getError(e),
        },
      }),
    );
  }
}

export function* findVehicleTypeSaga(): Generator {
  yield takeLatest(findBrandsByYearStart, findBrandsByYear);
  yield takeLatest(findModelsByYearAndBrandStart, findModelsByYearAndBrand);
}

const getVehicleTypeUrl = (vehicleType: VEHICLE_TYPE): string => {
  if (vehicleType === VEHICLE_TYPE.MOTORCYCLE) {
    return "motorcycle";
  }
  return "car";
};
